export const TOOLBAR_HEIGHT = '50px';

/** File extensions that the backend can convert to SFDT for in-app viewing */
export const SFDT_CONVERTIBLE_FORMATS: ReadonlySet<string> = new Set([
  'docx',
  'doc',
  'txt',
  'rtf',
]);
